import { CommonModule, isPlatformBrowser } from '@angular/common'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, OnInit, Output, PLATFORM_ID, QueryList, ViewChildren, effect, inject, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';


@Component({
  selector: 'iho-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss'],
  standalone: true,

  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
  ]
})

export class NotFoundComponent  {

  cdnUrl = 'https://www.iranhotelonline.com'

}
